import React from 'react';
import classNames from 'classnames';
import { Form as FinalForm } from 'react-final-form';
import { FormattedMessage, useIntl } from 'react-intl';

import { Button, FieldTextInput, Form } from '../../../../components';
import * as validators from '../../../../util/validators';
import { addEmailContact } from '../../api';

import css from './SignUpForm.module.css';

const SignUpForm = props => {
  const { className } = props;
  const intl = useIntl();

  const handleSubmitSignUpForm = values => {
    addEmailContact(values);
  };

  const emailPlaceholder = intl.formatMessage({
    id: 'SignUpForm.emailPlaceholder',
  });
  const submit = intl.formatMessage({ id: 'SignUpForm.submit' });

  const emailRequired = validators.required(
    intl.formatMessage({
      id: 'SignupForm.emailRequired',
    })
  );
  const emailValid = validators.emailFormatValid(
    intl.formatMessage({
      id: 'SignupForm.emailInvalid',
    })
  );

  return (
    <FinalForm
      className={classNames(className, css.root)}
      onSubmit={handleSubmitSignUpForm}
      subscription={{
        submitFailed: true,
        submitSucceeded: true,
      }}
      render={fieldRenderProps => {
        const { className, handleSubmit, submitFailed, submitSucceeded } = fieldRenderProps;

        const submittedMessage = submitSucceeded ? (
          <p className={css.submittedLabel}>
            <FormattedMessage id="SignUpForm.submittedLabelSuccess" />
          </p>
        ) : submitFailed ? (
          <p className={css.submittedLabel}>
            <FormattedMessage id="SignUpForm.submittedLabelFailed" />
          </p>
        ) : null;

        return (
          <div>
            <Form className={className} onSubmit={handleSubmit}>
              <FieldTextInput
                className={css.fieldInput}
                id="email"
                name="email"
                type="email"
                placeholder={emailPlaceholder}
                validate={validators.composeValidators(emailRequired, emailValid)}
              />

              <Button className={css.submit} type="submit">
                {submit}
              </Button>
            </Form>
            {submittedMessage}
          </div>
        );
      }}
    />
  );
};

export default SignUpForm;
